export const en = {
  opportunityRequestsPage: {
    page_title_requests: 'My Requests',
    page_title_events: 'My Created Events',
    requests: {
      title: 'Event Requests',
      subtext: 'Manage your event requests',
      empty_state: {
        title: 'No requests yet',
        description:
          "Looks like you haven't submitted any event requests.\nSubmit a new event request to start volunteering!",
      },
    },
    created_events: {
      title: 'My Created Events',
      subtext: 'Manage your created events',
      empty_state: {
        title: 'No Created Events',
        description: "Looks like you haven't created any events.",
      },
      search_placeholder: 'Search created events',
    },
    status_labels: {
      submitted: 'In Review',
      in_review: 'In Review',
      in_progress: 'In Progress',
      pending_your_feedback: 'Pending Your Feedback',
      fulfilled: 'Fulfilled',
      opportunity_completed: 'Event Completed',
      cancelled: 'Cancelled',
      published: 'Published',
      draft: 'Draft',
    },
    company_requests: {
      title: 'Event Requests',
      subtext: 'Manage your company’s requests',
      search_placeholder: 'Search by ID, name or email',
      empty_state: {
        title: 'No requests yet',
        description:
          "Looks like you haven't submitted any event requests.\nSubmit a new event request to start volunteering!",
      },
    },
    table: {
      columns: {
        submitted: 'Submitted',
        status: 'Status',
        last_updated: 'Last Updated',
        details: 'Details',
        name: 'Name',
        date: 'Date',
        dates: 'Dates',
        nonprofit: 'Nonprofit',
        submitted_by: 'Submitted By',
        company: 'Company',
        view_opportunity: 'View Event',
      },
      details: {
        target_audience: 'Target Audience',
        dates: 'Dates',
        location: 'Location',
        attendees: 'Attendees',
        times_of_day: 'Time(s) of day',
        additional_details: 'Additional Details',
      },
    },
    actions: {
      view_opportunity: 'View Event',
      edit_request: 'Edit Request',
      cancel_request: 'Cancel Request',
      edit_opportunity: 'Edit',
      delete: 'Delete',
      cancel_event: 'Cancel Event',
      no_actions: 'No actions available',
      create_new: 'Create New Event',
      new_request: 'New Request',
    },
    status: {
      all: 'All',
      submitted: 'Submitted',
      in_review: 'In Review',
      in_progress: 'In Progress',
      pending_your_feedback: 'Pending Your Feedback',
      fulfilled: 'Fulfilled',
      opportunity_completed: 'Event Completed',
      cancelled: 'Cancelled',
      published: 'Published',
      draft: 'Draft',
    },
    toggle: {
      attending: 'Requested',
      created: 'Created',
    },
    cancel_modal: {
      title: 'Cancel Event Request',
      message: 'Are you sure you want to cancel your event request?',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
    confirmDeleteModal: {
      title: 'Delete Event',
      message: 'Are you sure you want to delete your event request?',
      delete_progress_warning: 'Any progress will be permanently deleted.',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
    confirmCancelModal: {
      title: 'Cancel Event',
      message: 'Are you sure you want to cancel your event request?',
      cancel_event_warning:
        'This event has {{reservations}} volunteer(s) registered.',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
    created_events_table: {
      columns: {
        name: 'Name',
        date: 'Date',
        nonprofit: 'Nonprofit',
        status: 'Status',
      },
      status: {
        cancelled: 'Cancelled',
        published: 'Published',
        draft: 'Draft',
      },
      actions: {
        edit_opportunity: 'Edit Event',
        delete: 'Delete Event',
        cancel_event: 'Cancel Event',
        duplicate_opportunity: 'Duplicate Event',
      },
    },
    delete_unpublished_modal: {
      title: 'Delete Event',
      message: 'Are you sure you want to delete your event request?',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
    cancel_event_modal: {
      title: 'Cancel Event',
      message: 'Are you sure you want to cancel your event request?',
      buttons: {
        confirm: 'Yes',
        cancel: 'No',
      },
    },
  },
}
